import { theme } from '@chakra-ui/core';

const customTheme = {
    ...theme,
    fonts: {
        body: 'Roboto, sans-serif',
        heading: 'Roboto, sans-serif',
    }
};

export default customTheme;